import React from 'react'

function Tomorrow(): React.ReactElement {
  return <div>...</div>
}

export default Tomorrow
